/*
* Copyright © 2019 Insticator, Inc. All Rights Reserved.
*
* CONFIDENTIALITY NOTICE: THIS SOFTWARE CONTAINS CONFIDENTIAL INFORMATION OF
* INSTICATOR, INC. USE, DISCLOSURE OR REPRODUCTION IS PROHIBITED WITHOUT THE PRIOR
* EXPRESS WRITTEN PERMISSION OF INSTICATOR, INC.
*/

/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// SET STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)

export default {
	questionset: {
		width: '100%',
		height: '100%',
		position: 'relative',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-end',
		'& .answerset': {
			position: 'relative',
			// paddingTop: pxToEm(10),
			paddingBottom: pxToEm(7),
			height: hasRewardsComponent => hasRewardsComponent ? '70%' : '65%',
			width: '100%'
		},
		'& .result, .clicked': {
			// !!!!!!!!!!!!!! troy - prevent users from clicking on different answers after results screen is shown !!!!!!!!!!!!!!  //
			'& .answer': {
				pointerEvents: 'none'
			}
		}
	}
};
